import setShowFolderPane from './actions/setShowFolderPane';
import applyConversationFlaggedStateStitch from './stitches/applyConversationFlaggedStateStitch';
import updateItemMandatoryPropertiesStitch from './stitches/updateItemMandatoryPropertiesStitch';
import updateLoadedConversationStitch from './stitches/updateLoadedConversationStitch';
import { LazyAction, LazyModule } from 'owa-bundling';
import { runAfterBootstrap } from 'owa-delayed-initialization';
import './orchestrators/exitSearchOrchestrator';
export { getLeftNavWidth, getFolderListWidth, getSearchBoxLeftPadding, LEFT_RAIL_STATIC_WIDTH, MIN_NAVIGATION_BAR_WIDTH, MAX_NAVIGATION_BAR_WIDTH, } from './actions/getLeftNavWidth';
export { setShowFolderPane };
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "ToggleFolderPaneExpansion" */ './lazyIndex');
});
export var lazyToggleFolderPaneExpansion = new LazyAction(lazyModule, function (m) { return m.toggleFolderPaneExpansion; });
runAfterBootstrap(function () {
    applyConversationFlaggedStateStitch();
    updateItemMandatoryPropertiesStitch();
    updateLoadedConversationStitch();
});
//# sourceMappingURL=index.js.map